import { render, staticRenderFns } from "./SoilCharacteristicsTable.vue?vue&type=template&id=753f1512"
import script from "./SoilCharacteristicsTable.vue?vue&type=script&lang=js"
export * from "./SoilCharacteristicsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports